import React from 'react'
import {Navigate, useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {usePermission} from '../../hooks/usePermission'
import {WithChildren} from '../../../_metronic/helpers'

interface ProtectedRouteProps extends WithChildren {
  module: string
  requiredLevel: 'EDIT'
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  module,
  requiredLevel,
}) => {
  const intl = useIntl()
  const location = useLocation()
  const {hasAccess, userRole, userPermissions} = usePermission(module, requiredLevel)

  // If user doesn't have required access level
  if (!hasAccess) {
    // Check if user has any other module access
    const hasAnyOtherAccess = Object.entries(userPermissions || {})
      .some(([mod, perm]) => mod !== module && perm !== 'NONE')
    
    // If user has access to other modules, redirect to permission overview
    // Otherwise, redirect to access denied
    const redirectTo = hasAnyOtherAccess ? '/permission-overview' : '/access-denied'
    
    return (
      <Navigate
        to={redirectTo}
        state={{
          module,
          requiredLevel,
          currentLevel: userPermissions?.[module] || 'NONE',
          attemptedPath: location.pathname,
        }}
        replace
      />
    )
  }

  // Since we only have NONE and EDIT levels, no read-only mode is needed
  return <>{children}</>
}

export {ProtectedRoute}
